module.exports = __webpack_public_path__ + "img/skypark-offices.2d141070.png";